import request from '@/plugin/axios'

export function ListMessages (data) {
  return request({
    url: '/message/index',
    method: 'get',
    params: data
  })
}

export function GetAssistItems () {
  return request({
    url: '/message/assist-items',
    method: 'get'
  })
}

export function ViewMessage (id) {
  return request({
    url: '/message/view?id=' + id,
    method: 'get'
  })
}

export function CreateMessage (data) {
  return request({
    url: '/message/create',
    method: 'post',
    data
  })
}

export function ReadMessage (id, data) {
  return request({
    url: '/message/read?id=' + id,
    method: 'post',
    data
  })
}

export function EditMessage (data) {
  return request({
    url: '/message/update?id=' + data.id,
    method: 'post',
    data
  })
}

export function DeleteMessage (id) {
  return request({
    url: '/message/delete?id=' + id,
    method: 'delete'
  })
}

export function DeleteAllMessages (data) {
  return request({
    url: '/message/delete-all',
    method: 'post',
    data
  })
}

export function CleanAllMessages (data) {
  return request({
    url: '/message/clean-all',
    method: 'post',
    data
  })
}
